<template>
    <div class="bg-white p-4 rounded-xl">
        <div :class="`d-lg-flex ${filterDate ? 'justify-content-between' : 'justify-content-end'}`">
            <div v-if="filterDate">
                <div class="d-lg-flex d-flex gap-3 mb-2 mb-lg-0 align-items-center justify-content-between w-100">
                    <div class="text-left w-100">
                        <label for="" class="">Start Date</label>
                        <BFormInput type="date" class="" v-model="startDate"></BFormInput>
                    </div>
                    <div class="text-left w-100">
                        <label for="" class="">End Date</label>
                        <BFormInput type="date" class="" v-model="endDate"></BFormInput>
                    </div>
                </div> 
            </div>
            <div :class="`d-lg-flex align-items-center ${cta ? 'gap-lg-3 justify-content-end': 'justify-content-end'}`">
                <div class="d-flex gap-3 mb-2 mb-lg-0 align-items-center">
                    <BButton 
                        v-if="filterModal" 
                        class="btn-filter d-lg-flex d-flex align-items-center align-items-lg-center mb-lg-0" 
                        variant="light" @click="$emit('showFilter')">
                        <i class="fas fa-filter me-1"></i>
                        <span class="">Filter</span>
                    </BButton>
                    <BInputGroup 
                        class="border rounded-lg">
                        <template #append>
                            <BButton variant="white"><i class="ios ion-ios-search text-black"></i></BButton>
                        </template>
                        
                        <BFormInput type="text" class="border-0" placeholder="Search">
                    
                        </BFormInput>
                    </BInputGroup>
                </div>
                <div class="d-grid">
                    <BButton 
                        v-if="cta" 
                        class="btn-cta" 
                        variant="primary"
                         @click="$emit('action')">
                        <i class="fas fa-plus"></i> 
                        {{ ctaText }}
                    </BButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {BButton, BFormInput, BInputGroup} from "bootstrap-vue-next";

export default {
    name: 'ActionContent',
    components: {
        BButton, BFormInput, BInputGroup
    },
    props: {
        ctaText: String,
        filterDate: {
            type: Boolean,
            default: true,
        },
        filterModal: {
            type: Boolean,
            default: true,
        },
        cta: {
            type: Boolean,
            default: true,
        },
    }
}
</script>

<style>
@media screen and (min-width: 768px) {
    .col-lg-4{
        min-width: 184px;
    }
}
</style>